export const GET_SHIFTS_ERROR = "Une erreur est survenue lors du chargement des horaires.";

export const ADD_SHIFT_ERROR = "Une erreur est survenue lors l'ajout de l'horaire.";

export const UPDATE_SHIFT_ERROR = "Une erreur est survenue lors de la modification de l'horaire.";

export const DELETE_SHIFT_ERROR = "Une erreur est survenue lors de la suppression de l'horaire.";

export const GET_CLOSED_DAYS_ERROR = "Une erreur est survenue lors du chargement des jours de fermeture.";

export const ADD_CLOSED_DAY_ERROR = "Une erreur est survenue lors l'ajout de la fermeture.";

export const UPDATE_CLOSED_DAY_ERROR = "Une erreur est survenue lors de la modification de la fermeture.";

export const DELETE_CLOSED_DAY_ERROR = "Une erreur est survenue lors de la suppression de la fermeture.";

export const ADD_SPECIAL_OPENING_ERROR = "Une erreur est survenue lors de l'ajout de l'horaire d'ouverture spéciale.";


// WEBPACK FOOTER //
// ./src/errors/shifts.js